import { useParams } from "react-router";
import { CtaSequenceManager } from "@/components/pages/webinars/cta-sequence-manager";

export default function CtaSequenceBuilderPage() {
  const { webinarId } = useParams();

  return (
    <div className="p-6 max-w-5xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-[var(--color-foreground)]">CTA Sequence</h1>
        <p className="mt-1 text-sm text-[var(--color-muted-foreground)]">
          Build the live webinar CTA sequence, save it on the canonical webinar runtime, and trigger the next step without leaving the control stack.
        </p>
      </div>

      <CtaSequenceManager webinarId={webinarId} />
    </div>
  );
}
